import PropTypes from 'prop-types';

import { WebsiteComponentInteractionConfigurationPropType } from 'components/modules/website-component-interaction/proptypes';
import { ObjectPropType } from 'libs/proptypes';

import { ContentNodeType } from '../../content/types/content';

export const PageComponentFileType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  file: PropTypes.string.isRequired,
  order: PropTypes.number.isRequired,
});

export const PageComponentSettingType = PropTypes.shape({
  id: PropTypes.number.isRequired,
});

export const PageComponentType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
  fastId: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  enabled: PropTypes.bool,
  componentIdentifier: PropTypes.string,

  data: ObjectPropType,

  files: PropTypes.arrayOf(PageComponentFileType),
  contentNodes: PropTypes.arrayOf(ContentNodeType),
  interactions: PropTypes.arrayOf(WebsiteComponentInteractionConfigurationPropType),
});
